module.exports = __webpack_public_path__ + "img/emitHairstyleeditor04.f8aae6c4.png";